import _ from 'lodash';

import PageLayout, { LayoutComponents } from './PageLayout';
import Alerts from './Alerts';
import ContentWrapper from './ContentWrapper';
import Footer from './Footer';
import EditorFooter from './EditorFooter';
import Header from './Header';
import MainContent from './MainContent';
import Popups from './Popups';
import Sliders from './Sliders';
import Menu from './Menu';

export function modifyPageLayoutComponents(components) {
  return _.merge({}, LayoutComponents, components || {});
};


export {
  PageLayout,
  Alerts,
  ContentWrapper,
  Footer,
  EditorFooter,
  Header,
  Menu,
  MainContent,
  Popups,
  Sliders
};

export default PageLayout;
